module.exports = { id: "lock", url: "/build/app/img/symbols.svg#lock", viewBox: "", toString: function() { return this.url; } };